<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" epub:type="pagebreak" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2023 by The University of Chicago. Illustrations Copyright © 2023 by Matthew Green</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 East 60th Street, Chicago, IL 60637.</p>
<p class="crt">Published 2023</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">32 31 30 29 28 27 26 25 24 23     1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-82491-8 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-82492-5 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226824925.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226824925.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Mitchell, Ross (Geophysicist), author.</p>
<p class="cip">Title: The next supercontinent : solving the puzzle of a future Pangea / Ross Mitchell.</p>
<p class="cip">Description: Chicago : The University of Chicago Press, 2023. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2022044961 | ISBN 9780226824918 (cloth) | ISBN 9780226824925 (ebook)</p>
<p class="cip">Subjects: LCSH: Plate tectonics. | Geodynamics. | Pangaea (Supercontinent)</p>
<p class="cip">Classification: LCC QE511.5 .M58 2023 | DDC 551.1/36—dc23/eng20221230</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2022044961" target="_blank">https://lccn.loc.gov/2022044961</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-mitchell-0004.vue?63c80004